import styled from 'styled-components';
import { StockModelListStyledOV } from './StockModelListStyled.OV';

export const StockModelListStyledOVGB = styled(StockModelListStyledOV)`
    .last-item-wrapper {
        .last-item-banner-container-button {
            button {
                color: ${({ theme }) => theme.colors.white};
                background-color: ${({ theme }) => theme.colors.primary};

                &:hover {
                    background-color: ${({ theme }) => theme.colors.white};
                    color: ${({ theme }) => theme.colors.primary};
                    border: 2px solid ${({ theme }) => theme.colors.primary};
                }
            }
        }
    }
`;
